export default __webpack_public_path__ + "static/media/6f21909440b9ad84.bb33469b217b0894a87e7efa299d87b9.svg";